import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { FaseService } from '../../fase/fase.service';

import { Perfis } from '../../../models/perfis';
import { AuthService } from '../../admin/auth.service';

import { ExcelService } from '../../../services/excel.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DropdownModule } from 'primeng/primeng';
import { saveAs } from 'file-saver';

@Component({
  templateUrl: './relatorio-historico.component.html'
})
export class RelatorioHistoricoComponent
  extends WebPage
  implements OnInit
{
  fases;
  perfis: any = {};
  unidades = [];
  usuario: any = {};
  faseUnidade;
  candidatos = [];
  candidatosTxt = [];

  form: FormGroup;
  fileUrl;
  constructor(
    private fb: FormBuilder,
    private faseService: FaseService,
    messageService: MessageService,
    private authService: AuthService,
    private excelService: ExcelService,
    private sanitizer: DomSanitizer
  ) {
    super(messageService);
    this.form = this.fb.group({
      idFase: [null, Validators.required]
    });
  }

  ngOnInit() {
    this.isLoading = true;
    this.usuario = this.authService.informacoesUsuario();
    this.faseService
      .getAll()
      .finally(() => (this.isLoading = false))
      .subscribe(
        (fases) => (this.fases = fases),
        (error) => this.gerenciaErro(error)
      );
    
  }

  get idFase() {
    return this.form.controls.idFase;
  }

  baixarExcel() {
    this.faseService
      .getRelatorioHistoricoCandidatos(this.idFase.value)
      .finally(() => (this.isLoading = false))
      .subscribe(
        (candidatos) => {
          this.candidatos = candidatos;

          if (candidatos.every((ui) => ui.numeroInscritos === 0)) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Atenção',
              detail: 'Nenhum registro encontrado!'
            });
          }
        },
        (error) => this.gerenciaErro(error)
      );
    this.criarExcelRelatorioDetalhado(this.candidatos);
  }

  criarExcelRelatorioDetalhado(candidatos: any): void {
    const relatorio = [];
    this.isLoading = true;
    candidatos.forEach((x) => {
      relatorio.push({
        Unidade: x.unidade,
        CPF: x.cpf,
        Nome: x.nome,
        StatusHistorico: x.statusHistorico,
        Justificativa: x.justificativa
      });
    });

    const day = new Date().getDate();
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();

    this.excelService.exportAsExcelFile(
      relatorio,
      `SISPAC - Histórico participantes - ` + day + '_' + month + '_' + year
    );
    this.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/relatorio-historico/relatorio-historico.component.ts